module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Map/Marker#1-28094faa4e2e008eec7ee33fa55dca8a460cfcd80b2cc2b72df5cabb973d8641.svg";